import React from 'react'
import { Component } from 'react'
import { connect } from 'react-redux'
import {
    ClanTask,
    getClanTasks,
    claimClanTask,
    claimClanTasks,
} from '~/Actions/ActionClanTasks'
import ViewClanTasks, {IViewClanTasks} from '../Components/ViewClanTasks/ViewClanTasks'

export type ContainerClanTasks_Props = {
    router: any,

    isFetching: boolean,
    isClaiming: boolean,
    tasks: Array<ClanTask>,
    claimed: Array<ClanTask>,

    currentAccount?: any,
}

export type ContainerClanTasks_State = {
}

const mapStateToProps = (state) => {
    return {
        isFetching: state.ReducerClanTasks.isFetching,
        isClaiming: state.ReducerClanTasks.isClaiming,
        tasks: state.ReducerClanTasks.tasks,
        claimed: state.ReducerClanTasks.claimed,

        currentAccount: state.currentAccount,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getClanTasks: () => {
            dispatch(getClanTasks())
        },
        claimClanTask: (clanId: number) => {
            dispatch(claimClanTask(clanId))
        },
        claimClanTasks: () => {
            dispatch(claimClanTasks())
        },
    }
}

class ContainerClanTasks extends Component<ContainerClanTasks_Props, ContainerClanTasks_State> {

    constructor(props) {
        super(props)

        this.getClanTasks = this.getClanTasks.bind(this)
        this.claimClanTasks = this.claimClanTasks.bind(this)
        this.claimClanTask = this.claimClanTask.bind(this)
    }

    componentDidMount() {
        this.props.getClanTasks()
    }

    getClanTasks() {
        this.props.getClanTasks()
    }

    claimClanTask(taskId: number) {
        this.props.claimClanTask(taskId)
    }

    claimClanTasks() {
        this.props.claimClanTasks()
    }

    render() {

        return (
            <ViewClanTasks
                isFetching={this.props.isFetching}
                isClaiming={this.props.isClaiming}
                tasks={this.props.tasks}
                claimClanTasks={this.claimClanTasks}
                claimClanTask={this.claimClanTask}
                claimed={this.props.claimed}

                currentAccount={this.props.currentAccount} />
        )
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ContainerClanTasks)